import { HistoryLogRepository } from '../domain/HistoryLogRepository'
import { VueInvoiceHistoryLogListScreenData } from '../infra/VueInvoiceHistoryLogListScreenData'

export class InvoiceHistoryLogListComponent {

    screen_data: VueInvoiceHistoryLogListScreenData
    repo: HistoryLogRepository
    availableFilters: any

    constructor(screen_data: VueInvoiceHistoryLogListScreenData, repo: HistoryLogRepository, availableFilters?: any) {
        this.screen_data = screen_data
        this.repo = repo
        this.availableFilters = availableFilters || {}
    }

    async mountList(company_id: number): Promise<void> {
        this.screen_data.setLoading(true)

        // Recoger filtros activos
        let filters: Record<string, any> = {}
        if (this.availableFilters) {
            Object.values(this.availableFilters).forEach((element: any) => {
                if (element.value !== '' && element.value !== null && element.value !== undefined) {
                    filters[element.name] = element.value
                }
            })
        }

        let logs = await this.repo.find_by_company_id(company_id, this.screen_data.limit, this.screen_data.offset, filters)
        this.screen_data.invoiceHistoryLogs = logs.result
        this.screen_data.setTotalItems(logs.count)
        this.screen_data.setLoading(false)
        this.screen_data.calculateTableHeight()
    }

    async changeLimit(value: number, company_id:number): Promise<void> {
        this.screen_data.changeLimit(value)
        await this.mountList(company_id)
    }

    async changeOffset(value: number, company_id:number): Promise<void> {
        this.screen_data.changeOffset((value-1)*this.screen_data.limit)
        await this.mountList(company_id)
    }
    
}